<section class="gallery pb-5">
    <div class="container">
        <div class="inner-sec port-bg">
            <div class="sec-head">
                <h1 class="sec-title text-capitalize">portfolio</h1>
                <span class="block"></span>
            </div>
            <!-- portfolio-area -->
            <div class="row py-3">
                <ul class="portfolio-categ filter pb-md-5 pb-3 mb-4">
                    <li [ngClass]="['port-filter', cat.id === selectedCategory ? 'active': '']" *ngFor="let cat of categories" (click)="chooseCategory(cat.id)">
                        <a>{{cat.name}}</a>
                    </li>
                </ul>
                <ul class="portfolio-area clearfix">
                    <li class="portfolio-item2" *ngFor="let project of selectedProjects" [@fadeInOut]>
                        <span class="image-block img-hover">
                            <a class="image-zoom">
                                <img [src]="project.image" class="img-fluid" alt="Communal">
                            </a>
                            <span class="portfolio-item2--hover">
                                <h3>{{project.name}}</h3>
                                <div class="button-group">
                                    <a class="btn btn-outline-primary" [href]="getSanitizeUrl(project.githubLink)" target="_blank">Github</a>
                                    <a class="btn btn-outline-success" [href]="getSanitizeUrl(project.liveDemoLink)" target="_blank">Live Demo</a>
                                </div>

                            </span>
                        </span>
                    </li>
                </ul>
                <!--end portfolio-area -->
            </div>
        </div>
    </div>
</section>